import { render, staticRenderFns } from "./TeamCorrespondenceComponent.vue?vue&type=template&id=d790857a&scoped=true&"
import script from "./TeamCorrespondenceComponent.vue?vue&type=script&lang=ts&"
export * from "./TeamCorrespondenceComponent.vue?vue&type=script&lang=ts&"
import style0 from "./TeamCorrespondenceComponent.vue?vue&type=style&index=0&id=d790857a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d790857a",
  null
  
)

export default component.exports